import React from 'react';
import { Translation } from 'react-i18next';

import BillingPlansList
  from 'components/dashboard/billing-content/BillingPlansList';

import './BillingPageContent.css';

const BillingPageContent = () => (
  <Translation>
    {(t) => (
      <div className="billing-page-content__component">
        <div className="plans-header">
          <div className="title">{t("It's time to turn PRO")}</div>
          <div className="subtext">
            <div>
              {t("Get even more out of your bio link! Advanced analytics," +
                 "unlimited customisations, dedicated support and much more.")}
            </div>
            <div>{t("Upgrade or downgrade at any time.")}</div>
          </div>
        </div>
        <BillingPlansList />
      </div>
    )}
  </Translation>
);

export default BillingPageContent;
